import { ButtonSecondary } from '../../../../../../../../baseComponents/Button'
import TitleAndWhiteBoxLayout from '../../../../../../../../baseComponents/Layout/TitleAndWhiteBoxLayout'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { getAllWorkSheetGroupStatuses, getUserPermissions } from '../../../../../../../../utils/reducers/getters'
import { permissionCheck } from '../../../../../../../../baseComponents/PermissionChecker/function'
import useWorkSheetProductStatusUrls from '../../../../../../../../utils/hooks/sells/orders/useWorkSheetProductStatusUrls'
import WorkSheetsProductStatusFlowConnect from '../../../../../../../../specificComponents/inputTableLayouts/order/WorkSheetLayout/WorkSheetProductStatusFlow'

interface WorkSheetsProductStatusViewProps {
    setView: React.Dispatch<React.SetStateAction<'default' | 'product_status_view'>>
}

const WorkSheetsProductStatusView: React.FC<WorkSheetsProductStatusViewProps> = ({ setView }) => {
    const { t } = useTwinTranslation()
    const workSheetProductStatusURLs = useWorkSheetProductStatusUrls()
    const workSheetProductStatuses = getAllWorkSheetGroupStatuses()
    return (
        <TitleAndWhiteBoxLayout title={t('workSheets', 'Hojas de trabajo')} RightHeader={
            <div className='flex flex-wrap gap-y-5 items-center'>
                <ButtonSecondary className='mr-5' onClick={() => setView('default')}><TwinTrans transKey='changeView'>Cambiar vista</TwinTrans></ButtonSecondary>
            </div>} className='small_paddings_whitebox'>
            <WorkSheetsProductStatusFlowConnect workSheetProductStatusURLs={workSheetProductStatusURLs} workSheetProductStatuses={workSheetProductStatuses} readOnly={permissionCheck(getUserPermissions('sell.workSheetProductStatus'), 'update') ? false : true}/>
        </TitleAndWhiteBoxLayout >
    )
}

export default WorkSheetsProductStatusView